import React, {FC} from "react";
import * as fa from "@fortawesome/free-solid-svg-icons"
import {ModalFooter} from "@traas/lib/src/components/layout/ModalProvider";
import { Input } from "@traas/lib/src/components/form/Input";
import {useApiService} from "../../../lib/src/api/hooks/useApiService";
import config from "../config";
import {getToken} from "@ventumsoftware/react-toolkit";
import {useNavigate} from "react-router";
import {TimeRegistration} from "../../../lib/src/api/dto/TimeRegistration";
import {ValidationError} from "../api/api";
import {Employee} from "@traas/lib/src/api/dto/Employee";
import {Moment} from "moment";

export const EditHourRemarkModal: FC<{entries: TimeRegistration[], employee: Employee, day: Moment}> = ({entries, employee, day}) => {
  const navigate= useNavigate();
  const entry = entries.find((entry) => entry.workorderId === null)

  const {timeRegistrationService} = useApiService(config, getToken, navigate)
  const [remark, setRemark] = React.useState(entry?.remark ?? '')
  const [errors, setErrors] = React.useState<string[]>([])
  const confirm = async () => {
    if (entry === undefined) {
      await timeRegistrationService.add(employee.id, day.toDate(), 0, undefined, remark)
        .catch(e => {
          if (e instanceof ValidationError) {
            setErrors(Object.values(e.errors).flat())
          }
          throw e
        })
    } else {
      await timeRegistrationService.update(entry.id, entry.employeeId, entry.date, entry.hours, remark)
        .catch(e => {
          if (e instanceof ValidationError) {
            setErrors(Object.values(e.errors).flat())
          }
          throw e
        })
    }
  }

  return <form>
    <div className={"space-y-2"}>
      <Input label={'Opmerking'} value={remark} focus={true} onChange={setRemark} type={'textarea'}/>
      {errors.length > 0 && <div className={"text-red-600 text-sm"}>
        {errors.map((e, i) => <p key={i}>{e}</p>)}
      </div>}
      <ModalFooter icon={fa.faSave} text={"Opslaan"} onSubmit={confirm}/>
    </div>
  </form>

}
